import React, {Component} from 'react';
import {ImageLogo} from '../Redux/action';
import {connect} from 'react-redux';
import {FormattedMessage} from "react-intl";

class ImageTab extends Component {

	uploadImage = (e) => {
		const fileReader = new FileReader();
		const file = e.target.files[0];

		fileReader.onloadend = () => {
			this.props.imageLogo(fileReader.result);
		};

		fileReader.readAsDataURL(file);

		//TODO: use Image reducer to upload image to state
	};

	render() {
		return (
				<div>
					<div style={{position: 'relative'}} className="mb-2">
						<input type="file" onChange={this.uploadImage} className="custom-file-input" id="customFile"/>
						<label className="custom-file-label" htmlFor="customFile"><FormattedMessage id="image.choose" /></label>
					</div>
				</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return {
		imageLogo: (image) => dispatch(ImageLogo(image)),

	};

}

export default connect(null, mapDispatchToProps)(ImageTab);
